/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMcpVaultDeleteServer } from "../../funcs/llmMcpVaultDeleteServer.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteMcpServerRequest$inboundSchema,
};

export const tool$llmMcpVaultDeleteServer: ToolDefinition<typeof args> = {
  name: "llm-mcp-vault-delete-server",
  description: `Delete MCP server

Soft-deletes a user-owned MCP server and revokes its credentials.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMcpVaultDeleteServer(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
